import { css } from '@emotion/react';

import { mediaquery } from 'shared/styles/styleFunctions';
import theme from 'shared/styles/themes';

export default css({
  '&.brief-index-header': {
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: `${theme.space[3]} 0 ${theme.space[4]} 0`,
    '&__creator': {
      width: '100%',
      [mediaquery.md]: {
        height: '100%',
        width: 'unset',
      },
      '& > .pagination-control': {
        margin: 0,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '0 1rem',
        [mediaquery.md]: {
          width: 'unset',
        },
        '& > *:not(:last-child)': {
          marginRight: 0,
          [mediaquery.md]: {
            marginRight: theme.space[3],
          },
        },
      },
    },
  },
  '.brief-index-header': {
    '&__new-brief-button': {
      margin: '.75rem 0 .25rem',
    },
  },
});
